import React, { Component } from "react";

class ResizingCursors extends Component {
    state = {
        // left: [{ direction: "left", style: {} }],
        // right: [
        //     {
        //         direction: "right",
        //         style: { right: this.props.lang == "en" ? "0" : "0" }
        //     }
        // ],
        // fourDirections: [
        //     { direction: "top", style: { top: 0 } },
        //     { direction: "bottom", style: {} },
        //     { direction: "left", style: {} },
        //     {
        //         direction: "right",
        //         style: { right: this.props.lang == "en" ? "0" : "0" }
        //     }
        // ],
        // eightDirections: [
        //     {
        //         direction: "nw",
        //         style: {
        //             top: this.props.lang == "en" ? "-1px" : "1px",
        //             left: this.props.lang == "en" ? "-1px" : "1px"
        //         }
        //     },
        //     {
        //         direction: "ne",
        //         style: {
        //             top: this.props.lang == "en" ? "-1px" : "1px",
        //             right: this.props.lang == "en" ? "-1px" : "1px"
        //         }
        //     },
        //     {
        //         direction: "sw",
        //         style: {
        //             bottom: this.props.lang == "en" ? "-1px" : "1px",
        //             left: this.props.lang == "en" ? "-1px" : "1px"
        //         }
        //     },
        //     {
        //         direction: "se",
        //         style: {
        //             bottom: this.props.lang == "en" ? "-1px" : "1px",
        //             right: this.props.lang == "en" ? "-1px" : "1px"
        //         }
        //     },
        //     { direction: "top", style: {} },
        //     { direction: "bottom", style: {} },
        //     { direction: "left", style: {} },
        //     {
        //         direction: "right",
        //         style: { right: this.props.lang == "en" ? "0" : "0" }
        //     }
        // ]
    };

    render() {
        const { directionsNum } = this.props;
        return (
            <div style={this.props.style.holder}>
                {this.props.resiziersList.map((arr, index) => {
                    const {
                        direction,
                        style,
                        handlerStyle,
                        mouseDown,
                        handlerId
                    } = arr;
                    return (
                        <div draggable={false} key={index}>
                            {this.props.showCursorHandles ? (
                                <div
                                    onMouseDown={(e) =>
                                        mouseDown(e, direction, handlerId)
                                    }
                                    style={Object.assign({ ...style })}
                                >
                                    <div
                                        onMouseDown={(e) =>
                                            mouseDown(e, direction, handlerId)
                                        }
                                        style={handlerStyle}
                                        id={handlerId}
                                    ></div>
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default ResizingCursors;
